import { FC } from 'react';

import CraftCreate from 'src/components/CraftCreate';
import CraftTabbedForm from 'src/components/CraftTabbedForm';
import DetailsTab from './formTabs/Details';
import { ApiFieldRecord } from 'src/types';
import { apiFieldSchema, getFormValidator } from './validation';

const validateForm = getFormValidator();

const transformValues = (rawValues: Partial<ApiFieldRecord>) => {
  const values = apiFieldSchema.parse(rawValues);
  return {
    ...values,
    updated_at: 'now()',
  };
};

export const ApiFieldCreate: FC = () => (
  <CraftCreate header="Create API Field" transform={transformValues}>
    <CraftTabbedForm formType="create" validate={validateForm}>
      <DetailsTab mode="create" />
    </CraftTabbedForm>
  </CraftCreate>
);

export default ApiFieldCreate;
